/**
 * Mirror sales/purchases realtime — restarts when cloud_plan upgrades mid-session.
 */

import { useEffect } from 'react';
import { assertMirrorSyncAllowed } from '../../../services/cloudCapability';
import { CLOUD_PLAN_CHANGED_EVENT } from './useHybridRealtimeLifecycle';

export function useMirrorEntityRealtimeLifecycle({ enabled, businessId }) {
  useEffect(() => {
    if (!enabled || !businessId) {
      void import('../../../services/mirrorEntityRealtime').then(({ stopMirrorEntityRealtime }) =>
        stopMirrorEntityRealtime()
      );
      return undefined;
    }

    let cancelled = false;

    const tryStart = () => {
      if (cancelled) return;
      if (!assertMirrorSyncAllowed(businessId).allowed) {
        void import('../../../services/mirrorEntityRealtime').then(
          ({ stopMirrorEntityRealtime }) => stopMirrorEntityRealtime()
        );
        return;
      }
      void import('../../../services/mirrorEntityRealtime').then(({ startMirrorEntityRealtime }) =>
        startMirrorEntityRealtime(businessId)
      );
    };

    tryStart();

    const onOnline = () => tryStart();
    const onPlan = () => tryStart();
    window.addEventListener('online', onOnline);
    window.addEventListener(CLOUD_PLAN_CHANGED_EVENT, onPlan);

    return () => {
      cancelled = true;
      window.removeEventListener('online', onOnline);
      window.removeEventListener(CLOUD_PLAN_CHANGED_EVENT, onPlan);
      void import('../../../services/mirrorEntityRealtime').then(({ stopMirrorEntityRealtime }) =>
        stopMirrorEntityRealtime()
      );
    };
  }, [enabled, businessId]);
}
